// extracted by mini-css-extract-plugin
export default {"container":"tD-z","dimension":"uD-z","dimensionLabels":"vD-z"};